import { Component, OnInit } from '@angular/core';
import {
  FileType,
  GlobalConstantsColor,
  GlobalConstantsRouting,
  GlobalConstantsSonstige,
  GlobalFunctions,
  GlobalFunctionsGui,
} from 'globales-projekt-angular';
import { Router } from '@angular/router';
import { ConstantsTableColsErgebnisWindRichtlinienab } from 'src/app/immutable/constants-table-cols-ergebnis-wind-richtlinienab';
import { ErgebnisWindRichtlinienab } from 'src/app/data/ws/ergebnis-wind-richlinienab.model';
import { MatTableDataSource } from '@angular/material/table';
import { ConstantsErgebnisTableColsBerechnungen } from 'src/app/immutable/constants-table-cols-ergebnis-berechnungen';
import { UserBetrieb } from 'src/app/data/user/user-betrieb.model';
import { ApiService } from 'src/app/services/api.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { LocalService } from 'src/app/services/local.service';
import { Gebietskategorie } from 'src/app/data/ws/gebietskategorie.model';
import { FormControl } from '@angular/forms';
import { WindRichtlinienab } from 'src/app/data/ws/wind-richtlinienab.model';
import { ErgebnisBetrieb } from 'src/app/data/ws/ergebnis-betrieb.model';
import { ConstantsSonstige } from 'src/app/immutable/constants-sonstige';
//import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
//import { DomSanitizer } from '@angular/platform-browser';
@Component({
  selector: 'app-ergebnisse',
  templateUrl: './ergebnisse.component.html',
  styleUrls: ['./ergebnisse.component.css'],
})
export class ErgebnisseComponent implements OnInit {
  tooltipPosition = new FormControl(GlobalConstantsSonstige.POSITION_OPTIONS[0]);

  displayedColsErgebnisWindRichtlinienab: string[] =
    ConstantsTableColsErgebnisWindRichtlinienab.getColumns();
  displayedColsErgebnisBerechnungenList: string[] =
    ConstantsErgebnisTableColsBerechnungen.getColumns();

  dataErgebnisWindRichtlinienabList: MatTableDataSource<ErgebnisWindRichtlinienab> = new MatTableDataSource();
  dataErgebnisBerechnungenList: MatTableDataSource<ErgebnisBetrieb> = new MatTableDataSource();

  picWindhaeufigkeit: SafeUrl;
  picMindestabstand: SafeUrl;

  //userBetrieb: UserBetrieb = this.localService.aktuellerUserBetrieb.value.userBetrieb;
  ergebnisBetrieb: ErgebnisBetrieb = this.localService.ergebnisBetrieb.value;
  userBetrieb: UserBetrieb = this.localService.aktuellerUserBetrieb.value;

  readonly GlobalConstantsColor = GlobalConstantsColor;
  readonly maxGesamtemissionGeS = ConstantsSonstige.MAX_GESAMTEMISSION_GE_S;
  /*
  userBetriebList: UserBetrieb[] = SessionStorageService.getItem(
    GlobalConstantsStorage.EINGABE_DATEN_LIST
  );

  


  ergebnisse: Ergebnis = SessionStorageService.getItem(
    GlobalConstantsStorage.BERECHNUNGSERGEBNISSE_LIST
  )[0];
  e
  );
*/

  constructor(
    private sanitizer: DomSanitizer,
    private apiService: ApiService,
    private router: Router,
    public localService: LocalService,
  ) {


  }

  ngOnInit(): void {

    this.loadErgebnisse();
  }

  loadErgebnisse() {
    this.dataErgebnisBerechnungenList.data = [this.ergebnisBetrieb];

    this.dataErgebnisWindRichtlinienabList.data = this.ergebnisBetrieb.ergebnisWindRichtlinienabList.map(dto => Object.assign(new WindRichtlinienab(), dto));



    this.localService.mainComponentRef.value?.waitingForDataSpinner(true);
    this.apiService
      .postPicAbstand(this.userBetrieb)
      .subscribe(async (response: Blob) => {
        const blobToBase64 = (blob: Blob) =>
          new Promise((resolve, reject) => {
            const reader: FileReader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
          });

        let objectURL: any = await blobToBase64(response);
        objectURL = 'data:image/png;base64,' + objectURL.split(',')[1];

        this.picMindestabstand = this.sanitizer.bypassSecurityTrustUrl(objectURL);
        this.localService.mainComponentRef.value?.waitingForDataSpinner(false);
      });

    this.localService.mainComponentRef.value?.waitingForDataSpinner(true);
    this.apiService
      .postPicWind(this.userBetrieb)
      .subscribe(async (response: Blob) => {
        const blobToBase64 = (blob: Blob) =>
          new Promise((resolve, reject) => {
            const reader: FileReader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
          });

        let objectURL: any = await blobToBase64(response);
        objectURL = 'data:image/png;base64,' + objectURL.split(',')[1];

        this.picWindhaeufigkeit = this.sanitizer.bypassSecurityTrustUrl(objectURL);
        this.localService.mainComponentRef.value?.waitingForDataSpinner(false);
      });
  }


  zuMainSeite() { 
    this.router.navigate([GlobalConstantsRouting.MAIN]);
  }

  onClickExportBetrieb()
  {
    this.localService.betriebComponentRef.getValue().onClickExportBetrieb();
  }


  onClickDownloadExcel() {
    this.localService.mainComponentRef.value?.waitingForDataSpinner(true);


    //    for (let entry of this.userEingaben) {
    //     if (entry.bezeichnung == ergebnis.bezeichnung) {
    {
      this.apiService
        .postDownloadExcel(this.userBetrieb)
        .subscribe((response: Blob) => {
          let filename: string = this.userBetrieb.bezeichnung;

          GlobalFunctions.downloadFile(
            FileType.XLSX,
            response,
            filename,
            FileType.XLSX_SHORT
          );
          this.localService.mainComponentRef.value?.waitingForDataSpinner(false);
        });

      //    break;
    }
    //    }
    //   }
  }

  onClickDownloadPdf() {
    this.localService.mainComponentRef.value?.waitingForDataSpinner(true);

    //  for (let entry of this.userDatenEingabe) {
    //  if (entry.bezeichnung == ergebnis.bezeichnung) {
    {
      this.apiService
        .postDownloadPdf(this.userBetrieb)
        .subscribe((response: BlobPart) => {
          let filename: string = this.userBetrieb.bezeichnung;

          GlobalFunctions.downloadFile(
            FileType.PDF,
            response,
            filename,
            FileType.PDF_SHORT
          );
          this.localService.mainComponentRef.value?.waitingForDataSpinner(false);
        });

      //    break;
    }
    //  }
    // }
  }

  getGebietskategorieText(idGebietskategorie: number): string {
    let gebietskategorieList: Gebietskategorie[] = this.localService.globalWSData.value;
    if (gebietskategorieList) {
      let gebietskategorie: Gebietskategorie = gebietskategorieList.find(
        (item) => item.idGebietskategorie === idGebietskategorie
      );
      return gebietskategorie.gebietskategorie;
    }

    return "???";
  }

  onClickUp() {
    GlobalFunctionsGui.clickUp();
  }

  onClickDown() {
    GlobalFunctionsGui.clickDown();
  }
}
